'use client';

import dynamic from 'next/dynamic';

const GoogleAdsEnhancedTracking = dynamic(
	() => import('@/components/tracking/GoogleAdsEnhancedTracking'),
	{ ssr: false },
);

export const DeferredGoogleAdsEnhancedTracking = () => {
	return <GoogleAdsEnhancedTracking />;
};
